import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { headCells } from 'containers/pages/users/data';
import { storeSelectedContact } from 'redux/userMgt/userMgtSlice';

const useExistList = () => {
	const dispatch = useDispatch();
	const [page, setPage] = useState(0);
	const [perPage, setPerPage] = useState(5);
	const [selected, setSelected] = useState([]);

	function onPage(e, newPage) {
		setPage(parseInt(newPage));
	}

	function onPerPage(e) {
		setPerPage(parseInt(e.target.value, 10));
		setPage(0);
	}

	function checkSelected(id) {
		return selected.indexOf(id) !== -1;
	}

	function onGetContact(contact) {
		if (contact.id !== '') {
			const selectedIndex = selected.indexOf(contact.id);
			if (selectedIndex === -1) {
				setSelected(contact.id);
			}
			dispatch(storeSelectedContact(contact));
		}
	}

	return {
		page,
		perPage,
		onPage,
		onPerPage,
		headCells,
		onGetContact,
		checkSelected,
	};
};

export default useExistList;
